import { Component, Input } from '@angular/core';
import { CalculatorEfficiencies } from '../../../../data-access/models/calculator-efficiencies.model';
import { DecimalPipe } from '@angular/common';

@Component({
  selector: 'app-available-funds',
  templateUrl: './available-funds.component.html',
  styleUrls: ['./available-funds.component.scss'],
  standalone: true,
  imports: [DecimalPipe],
})
export class AvailableFundsComponent {
  @Input() funds: CalculatorEfficiencies[] = [];
}
